export default {
  header: 'Kostnad',
  total: 'Totalkostnad',
  perLiter: 'Kostnad per liter',
  perBottle075: 'Kostnad per flaske (0.75)',
  perBottle033: 'Kostnad per flaske (0.33)',
  perCan033: 'Kostnad per boks (0.33)',
};
